import {useTranslation} from "react-i18next";
import {statisticsType} from "@ots-frontend/ots-data";
import {useMemo} from "react";
import {ByInsight, ByInsightProps} from "../ByInsight/ByInsight";
import {ActionIcon, Flex} from "@mantine/core";
import {IconSearch} from "@tabler/icons-react";
import {useNavigate} from "react-router-dom";

export type LoadsByInsightProps = Omit<ByInsightProps, 'statisticsType' | 'title'> & {
  title?: string
  showSearch?: boolean
}

export const LoadsByInsight = (props: LoadsByInsightProps) => {
  const {
    title,
    showSearch = false,
    ...rest
  } = props

  const {t} = useTranslation()
  const navigate = useNavigate()

  const insightTitle = useMemo(() => {
    return title ?? t("common.insight.loadsby", "Loads By")
  }, [title, t])

  return (
    <ByInsight
      {...rest}
      title={insightTitle}
      statisticsType={statisticsType.loads}>
      {showSearch &&
        <Flex justify="flex-end">
          <ActionIcon onClick={() => navigate("/insights/loads-by")}>
            <IconSearch size="1.125rem"/>
          </ActionIcon>
        </Flex>
      }
    </ByInsight>
  )
}
